import { useMemo, useState, useEffect, memo } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectMarkersBySnapshotId } from '../markers/markersSlice';
import { DataGrid, GridSelectionModel } from '@mui/x-data-grid';

import { buildTableRows, tableColumns } from './utils/markerHistory';

import { TraceHistory } from '../../types';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';

interface MarkerHistoryProps {
  snapshotId: number;
  traces: TraceHistory[] | null;
  moveTraceIndexById: (id: number) => void;
  selectedTraceId: number;
}

const MarkerHistory = memo(
  ({
    snapshotId,
    traces,
    moveTraceIndexById,
    selectedTraceId,
  }: MarkerHistoryProps) => {
    const { timezone, dateFormat, timeFormat } = useUserDateTime();
    const selectCurrentMarkers = useMemo(selectMarkersBySnapshotId, []);
    const markers = useAppSelector((state) =>
      selectCurrentMarkers(state, snapshotId)
    );

    const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([
      selectedTraceId,
    ]);

    const handleRowClicked = (newSelectionModel: GridSelectionModel) => {
      setSelectionModel(newSelectionModel);
      moveTraceIndexById(Number(newSelectionModel[0]));
    };

    useEffect(() => {
      setSelectionModel([selectedTraceId]);
    }, [selectedTraceId]);

    if (!traces || markers.length < 1)
      return (
        <>
          <span>No markers placed for marker history.</span>
        </>
      );

    const rows = buildTableRows(
      traces,
      markers,
      timezone,
      `${dateFormat} ${timeFormat}`
    );

    return (
      <div style={{ height: '100%', overflow: `auto` }}>
        <DataGrid
          density='compact'
          rows={rows}
          columns={tableColumns}
          selectionModel={selectionModel}
          onSelectionModelChange={(newSelectionModel) => {
            handleRowClicked(newSelectionModel);
          }}
        />
      </div>
    );
  }
);

export default MarkerHistory;
